import { html } from "lit";
import { customElement } from "lit/decorators.js";
import { PageElement } from "../lib/page-element.js";
import { shared } from "../styles.js";

/** page-not-found is the router fallback for unmatched in-app paths. */
@customElement("page-not-found")
export class PageNotFound extends PageElement {
  static override styles = [shared];

  override firstUpdated() {
    this.setTitle("Not found");
    super.firstUpdated();
  }

  override render() {
    return html`
      <div class="wrap-narrow">
        <h1>Not found</h1>
        <p class="muted">No such page. <a href="/">Back to browse</a>.</p>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "page-not-found": PageNotFound;
  }
}
